import React from 'react';
import { Col, Row } from 'react-bootstrap';
import CustomWidget from '../Custom/CustomWidget';
import DCProfile from '../EnergyEfficiencyApp/EEReports/DCProfile';

const TabBattery = ({ hirarchy }) => (
  <Row>
    <Col lg={12}>
      <CustomWidget size={12} id={'chrtBattery'} title={'DC Profile'}>
        <DCProfile id={hirarchy.level.value} />
      </CustomWidget>
    </Col>
  </Row>
);

export default TabBattery;
